//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'message'
let resource_name = 'sugerencia'
let resource_name_plural = 'sugerencias'

let state = {

}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request_sam.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async addToBlock ({ commit }, params) {
    try {
      let res = await Vue.request_sam.patch(`${resource}s/${params.id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agregando ${resource_name} a bloque.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando ${resource_name} a bloque.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request_sam.delete(`${resource}s/${params.id}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeItem', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async sendMessage ({ commit }, { params = {}, callback = () => {} }) {
    try {
      const res = await Vue.request.post(
        `account/${params.account_id}/training/test`,
        params
      )

      const { data } = res

      if (data.success === null || data.success === undefined) {
        throw new Error(`Ocurrió un error enviando la ${resource_name}.`)
      }

      return callback(data)
    } catch (e) {
      console.error(e)

      const data = { error: e.message }

      return callback(data)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  removeItem (state, item) {
    let index = state[resource + 's'].findIndex(i => i.id == item.id)
    if(index >= 0) {
      state[resource + 's'].splice(index, 1)
    }
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
